var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.className,attrs:{"href":_vm.socialPath,"data-social":_vm.buttonName,"data-social-path":_vm.socialPath,"data-social-href":_vm.socialHref}},[_c('span',{class:_vm.$style.icon},[_c('base-icon',{attrs:{"type":_vm.iconName}})],1),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }